import * as React from "react";
import {Grid2 as Grid} from "@mui/material";
import dayjs from "dayjs";
import StringInputField from "@/lib/components/inputfields/string-input-field";
import {CardEx} from "@/lib/components/CardEx";
import {DateFormatter} from "@/lib/components/DateFormate";
import {useTranslation} from "react-i18next";
import {RequestI18N} from "@/translations";
import {UserDisplayDTO} from "@/api/data-contracts";
import {getFullName} from "@/model/user";

export type InternalConfirmationCardProps = {
    internalConfirmationReason?: string | null;
    internalConfirmationDate?: string | null;
    internalConfirmationBy?: UserDisplayDTO | null;
};

export const InternalConfirmationCard = ({
    internalConfirmationReason,
    internalConfirmationDate,
    internalConfirmationBy
}: InternalConfirmationCardProps) => {
    const {t} = useTranslation();

    // Nur anzeigen, wenn eine Begründung vorhanden ist (AC 11)
    if (!internalConfirmationReason?.trim()) {
        return null;
    }

    const formattedDate = internalConfirmationDate
        ? dayjs(internalConfirmationDate).format(DateFormatter("date"))
        : "";
    const confirmedByName = getFullName(internalConfirmationBy ?? undefined);

    return (
        <CardEx title={t(RequestI18N.details.page.internalConfirmationCardTitle)}>
            <Grid container spacing={2}>
                <Grid size={{sm: 12}}>
                    <StringInputField
                        label={t(RequestI18N.details.field.internalConfirmationReason)}
                        value={internalConfirmationReason.trim()}
                        multiline
                        minRows={3}
                        disabled
                    />
                </Grid>
                <Grid size={{sm: 12}}>
                    <StringInputField
                        label={t(RequestI18N.details.field.internalConfirmationDate)}
                        value={formattedDate}
                        disabled
                    />
                </Grid>
                <Grid size={{sm: 12}}>
                    <StringInputField
                        label={t(RequestI18N.details.field.internalConfirmationBy)}
                        value={confirmedByName}
                        disabled
                    />
                </Grid>
            </Grid>
        </CardEx>
    );
};
